import { useEffect, useRef } from "react";

const useCloseSelector = (closeHandler: () => void) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        closeHandler(); // Закрываем селектор, если клик был вне области ref
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [closeHandler]);

  return { ref };
};

export default useCloseSelector;
